import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { validateForm } from '../../../../shared/form-elements/form-validateForm.function';
import { SystemMessage, SystemMessageService } from '../../../../core/system-message/system-message-service';
import { SiteService } from '../../../../sites/site.service';
import { SiteDailyCountEventVm } from '../../../../shared/generated/Sites/Models/DailyCount/SiteDailyCountEventVm';
import { SiteDailyCountInventoryListVm } from '../../../../shared/generated/Sites/Models/DailyCount/SiteDailyCountInventoryListVm';
import { SiteHolidaysComponent } from '../../../../sites/site-holidays/site-holidays.component';

@Component({
    selector: 'pcg-public-site-daily-count',
    templateUrl: './public-site-daily-count.component.html',
    styleUrls: ['./public-site-daily-count.component.scss'],
    standalone: false
})
export class PublicSiteDailyCountComponent implements OnInit {

	@ViewChild('form') formEl: ElementRef;

	formSaveTouched = false;
	dailyCounts: SiteDailyCountInventoryListVm[] = [];
	formGroup = SiteDailyCountEventVm.Form;
	model = SiteDailyCountEventVm.GetModel(this.formGroup);
	model$: Observable<SiteDailyCountEventVm>;

	canEdit = true;
	isExpired = false;
	code: string;
	email: string;

	constructor(
		private siteService: SiteService
		, private ms: SystemMessageService
		, private activatedRoute: ActivatedRoute
		, private modalService: NgbModal
	) {}

	ngOnInit() {
		if (this.activatedRoute.snapshot.queryParamMap.get('code')) {
			var codeParam = this.activatedRoute.snapshot.queryParamMap.get('code');
			this.code = codeParam!;
			if (this.activatedRoute.snapshot.queryParamMap.get('email')) {
				var emailParam = this.activatedRoute.snapshot.queryParamMap.get('email');
				this.email = emailParam!;
			}
		}
		this.model$ = this.siteService.getPublicDailyCountEvent(this.code).pipe(
			tap((model: SiteDailyCountEventVm) => {
				this.formGroup.patchValue(model);
				this.formGroup.controls['submissionUserEmail'].patchValue(this.email);
				this.dailyCounts = model.siteDailyCountInventoryList;
				if (model.isComplete) { 
					if (!model.canEditDailyCountAfterCompleted) { this.canEdit = false; }					
				}
				if (model.isGuidExpired) {
					this.isExpired = true;
					this.canEdit = false;
				}
			})
		);
	}

	saveForm() {
		this.formSaveTouched = true;
		if (!this.formEl.nativeElement.checkValidity()) {
			this.ms.setSystemMessage('Please fill out each On Hand field before submitting', 'warning');
			return false;
		}
		if (this.formGroup.valid) {
			this.mapTableDataToFg();
			// Send the save request
			this.ms.getHttpObservable(this, 'api/SiteDailyCountEvent/SaveDailyCountEvent', this.formGroup)
				.subscribe(msg => { this.saveReturn(msg); });
		} else {
			validateForm(this.formGroup);
			return false;
		}
	}

	mapTableDataToFg() {
		// Add the blind current stock values to the form
		this.formGroup.controls.siteDailyCountInventoryList.setValue(
			this.dailyCounts.map(row => ({
				id: row.id,
				siteInventoryId: row.siteInventoryId,
				administered: row.administered,
				onHand: row.onHand
			}))
		);
	}

	saveReturn(msg: SystemMessage) { if (!msg?.model?.canEditDailyCountAfterCompleted) { this.canEdit = false; } }
	openSiteHolidayModal() { this.modalService.open(SiteHolidaysComponent, { size: 'lg' }); }
}
